import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_LIST_QUERY = graphql(/* GraphQL */ `
  query TesseractContractDemandList(
    $offset: Int
    $limit: Int
    $filter: TsrctQueryBuilderQuery
    $order: [TsrctContractDemandOrder!]
  ) {
    tesseract {
      contractDemands(offset: $offset, limit: $limit, filter: $filter, order: $order) {
        nodes {
          commodityGroupId
          createdAt
          description
          id
          status
          priority
          responsibleUserId
          sequenceNumber
          tagIds
          validFrom
          validTo
          totalValue
          currency
          openCaseCount
          negotiatedCaseCount
          totalCaseCount
        }
        totalCount
      }
    }
  }
`);
